"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ServiceItemDuration["default"];
  }
});
var _ServiceItemDuration = _interopRequireDefault(require("./ServiceItemDuration"));